import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import maintenance from './modules/maintenance'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    user,
    maintenance
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js